import api from '@/apis/di/sysAccountParallelVoucherListRuleDetailAPI';
import Crud from '@/stores/crudBaseCache';
var crud = new Crud('sysAccountParallelVoucherListRuleDetail', api);
const state = {
  ...crud.state,
  _config: {
    table: 'sys_account_parallel_voucher_list_rule_detail',
    field: {
      key: 'rule_detail_id',
      foreignKey: 'rule_id',
      sign: 'sign',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Lấy chia tiết dữ liệu rule hạch toán đồng thời theo id
   * @param {*} context
   * @returns
   * HTHIEP 08.07.2022
   */
  async getDataById(context, id) {
    const items = await api.getDataById(id);
    if (!items) {
      return;
    }
    return items;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
